<template>
  <div>
    <header-block title="Christmas Quiz Complete" ></header-block>
      <div class="textContainer">
        <h2 class="title">Wrong!</h2>

        <p class="paragraph">
          Better luck next time
        </p>

        <p v-if="questionnaire">{{ explainerText }}</p>
        <div class="anchor-bottom">
          <MGButton c:arrow="true" @click="$router.push('/')" text="Done" />
        </div>
    </div>
  </div>
</template>

<script>
import HeaderBlock from './elements/HeaderBlock.vue';
import Services from '../mixins/Services';
import MGButton from './elements/MGButton.vue';

export default {
  name: 'ChristmasQuizCompleteWrong',
  mixins: [Services],
  components: {
    HeaderBlock, MGButton
  },
  data() {
		return {
			explainerText: null
    }
  },
  methods: {
    onLoad: async function() {
      this._getQuestionnaireByGuidOrKey(this.$route.params.id, () => {
        this.explainerText = this.questionnaire.questionnaireQuestions[0].question.explainer;
      });
    }
  },
  mounted: function () {
		this.onLoad();
	},
};
</script>

<style scoped>

.paragraph {
  font-size: 13px;
  line-height: 24px;
  margin-bottom: 16px;
}
.imageContainer {
    /* margin: -20px -30px 0px -30px; */
    margin-left: -30px;
    margin-right: -30px;
    background-size: cover;
    margin-top: -20px;
    /* padding-top: 155px; */
}

.textContainer {
  padding: 40px 20px;
  margin-left: -30px;
  margin-right: -30px;
  text-align: center;
}

.paymentMethods {
  position: relative;
  width: 200px;
  margin: 20px auto 0 auto;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 16px;
}

.footerText {
  padding: 40px 20px;
  text-align: center;
}

.footerText p {
  font-size: 11px;
}

.circle {
  background-color: white;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  margin-bottom: 10px;
  font-size: 24px;
  font-weight: bold;
}
</style>
